import React, { useState, useContext, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";

const PasswordChange = () => {
  const { changePassword } = useContext(AuthContext);
  const [username, setUsername] = useState(""); // Store username from localStorage
  const [formData, setFormData] = useState({
    verificationCode: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const storedUsername = localStorage.getItem("username");
    if (storedUsername) {
      setUsername(storedUsername); // Retrieve username from localStorage
    } else {
      setMessage("Username not found. Please try again.");
    }
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage("");

    if (formData.newPassword !== formData.confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    setLoading(true);
    try {
      await changePassword({
        username,
        verificationCode: formData.verificationCode,
        newPassword: formData.newPassword,
      });
      setMessage("Password changed successfully.");
      navigate("/login"); // Redirect to login
    } catch (err) {
      setMessage(err.message || "Failed to change password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img
          alt="Your Company"
          src={`${process.env.PUBLIC_URL}/assets/hive.png`}
          className="mx-auto h-20 w-auto"
        />
        <h2 className="mt-10 text-center text-2xl font-bold tracking-tight text-[#414141]">
          Change Your Password
        </h2>
        <p className="mt-2 text-center text-sm text-gray-500">
          Username: <strong>{username}</strong>
        </p>
      </div>

      <div className="mt-10 sm:mx-auto sm:w-full sm:max-w-sm">
        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label
              htmlFor="verificationCode"
              className="block text-sm font-medium text-[#414141]"
            >
              Verification Code
            </label>
            <div className="mt-2">
              <input
                id="verificationCode"
                name="verificationCode"
                type="text"
                required
                value={formData.verificationCode}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-[#414141] outline outline-1 -outline-offset-1 outline-[#f7b22d] placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#f7b22d] sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="newPassword"
              className="block text-sm font-medium text-[#414141]"
            >
              New Password
            </label>
            <div className="mt-2">
              <input
                id="newPassword"
                name="newPassword"
                type="password"
                required
                value={formData.newPassword}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-[#414141] outline outline-1 -outline-offset-1 outline-[#f7b22d] placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#f7b22d] sm:text-sm"
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="confirmPassword"
              className="block text-sm font-medium text-[#414141]"
            >
              Confirm Password
            </label>
            <div className="mt-2">
              <input
                id="confirmPassword"
                name="confirmPassword"
                type="password"
                required
                value={formData.confirmPassword}
                onChange={handleChange}
                className="block w-full rounded-md bg-white px-3 py-1.5 text-base text-[#414141] outline outline-1 -outline-offset-1 outline-[#f7b22d] placeholder:text-gray-400 focus:outline focus:outline-2 focus:-outline-offset-2 focus:outline-[#f7b22d] sm:text-sm"
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-md bg-[#f7b22d] px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-[#414141] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f7b22d]"
              disabled={loading}
            >
              {loading ? "Changing Password..." : "Change Password"}
            </button>
          </div>
        </form>

        {message && (
          <div
            className={`mt-4 text-center text-sm ${
              message.includes("success") ? "text-green-500" : "text-red-500"
            }`}
          >
            {message}
          </div>
        )}
      </div>
    </div>
  );
};

export default PasswordChange;
